<template>
  <a-modal
    :title="form.user_id ? '修改用户信息' : '新增用户信息'"
    :visible="visible"
    :confirm-loading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    destroyOnClose
    :maskClosable="false"
  >
    <a-form-model
      ref="ruleForm"
      :model="form"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-form-model-item label="登录名" prop="username">
        <a-input v-model="form.username" placeholder="请输入登录名" />
      </a-form-model-item>
      <a-form-model-item label="登录密码" prop="password">
        <a-input-password
          v-model="form.password"
          placeholder="请输入登录密码"
          password
        />
      </a-form-model-item>
      <a-form-model-item
        label="所属部门"
        ref="department_id"
        prop="department_id"
      >
        <department-select
          ref="departmentSelect"
          v-model="form.department_id"
          allowClear
        ></department-select>
      </a-form-model-item>
      <a-form-model-item label="用户角色" prop="role_id">
        <a-select v-model="form.role_id" placeholder="请选择用户角色">
          <a-select-option :value="v.id" v-for="v in roleList" :key="v.id">
            {{ v.role_name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="真实姓名" prop="real_name">
        <a-input v-model="form.real_name" placeholder="请输入用户真实姓名" />
      </a-form-model-item>
      <a-form-model-item label="员工手机号" prop="user_phone">
        <a-input v-model="form.user_phone" placeholder="请输入员工11位真实电话" />
      </a-form-model-item>
      <a-form-model-item label="性别" prop="user_gender">
        <a-radio-group name="radioGroup" v-model="form.user_gender">
          <a-radio value="1"> 男 </a-radio>
          <a-radio value="2"> 女 </a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="联系邮箱" prop="user_email">
        <a-input v-model="form.user_email" placeholder="请输入联系邮箱" />
      </a-form-model-item>
      <a-form-model-item ref="user_remark" label="用户备注" prop="user_remark">
        <a-input v-model="form.user_remark" placeholder="请输入用户备注" />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      roleList: [],
      form: {
        group_id: undefined,
        department_id: undefined,
        role_id: undefined,
        user_id: "",
        username: "",
        password: "",
        real_name: "",
        user_gender: "1",
        user_phone: "",
        user_email: "",
        user_remark: "",
      },
      department_tree: [],
      groupList: [],
      loadingGroup: false,
      rules: {
        group_id: {
          required: true,
          message: "请选择所属集团",
          trigger: "change",
        },
        department_id: {
          required: true,
          message: "请选择所属项目",
          trigger: "change",
        },
        role_id: {
          required: true,
          message: "请选择用户角色",
          trigger: "change",
        },
        username: [
          {
            required: true,
            message: "请输入用户名称",
            trigger: "blur",
          },
          {
            min: 3,
            max: 32,
            message: "输入长度为3-32位",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "请输入登录密码",
            trigger: "blur",
          },
          {
            min: 6,
            max: 32,
            message: "输入长度为6-32位",
            trigger: "blur",
          },
        ],
        user_phone: {
          required: true,
          message: "请输入真实手机号",
          trigger: "blur",
        },
        real_name: {
          required: true,
          message: "请输入员工姓名",
          trigger: "blur",
        },
      },
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
    };
  },
  methods: {
    init(id) {
      this.visible = true;
      this.form.user_id = id;
      this.getRoleList();
      if (id) {
        this.$http({
          url: "/admin/user/info",
          method: "post",
          data: {
            user_id: id,
          },
        }).then((res) => {
          this.form = {
            ...res.data,
            role_id: parseInt(res.data.role_id),
          };
        });
      }
    },
    //获取角色列表
    getRoleList() {
      this.$http({
        url: "/admin/role/page?page=1&limit=200",
        method: "get",
      }).then((res) => {
        this.roleList = res.data.result || [];
      });
    },
    handleOk() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          console.log(this.form);
          this.confirmLoading = true;
          this.$http({
            url: this.form.user_id
              ? "/admin/user/update"
              : "/admin/user/create",
            method: "post",
            data: this.form,
          })
            .then(() => {
              this.$message.success(
                this.form.user_id ? "修改成功" : "创建成功"
              );
              this.handleCancel();
              this.$emit("ok");
            })
            .catch(() => {
              this.confirmLoading = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleCancel() {
      this.visible = false;
      this.confirmLoading = false;
      this.$refs["ruleForm"].resetFields();
    },
    handleChangeDepartment(e) {
      this.$nextTick(() => {
        this.$refs.department_id.onFieldBlur();
      });
      this.getRoleList(e);
    },
  },
};
</script>

<style>
</style>